import React from 'react';
import PropTypes from 'prop-types';
import DashboardHeatIndex from './DashboardHeatIndex';
import { getPublicDashboardToken } from '../../services/dashboardApi';
import HasRolePrivileges from '../../../highorder/HasRolePrivileges';
import { RaaRoles } from '../../../../utility/SecurityRules';

// A plausible-looking sample value so the gauge in the background renders
// something recognizable. Locked to Fahrenheit for the example — the real
// widget will pick up the user's preference once configured.
const STUB_VALUE = 95;
const STUB_UNITS = 'F';
const STUB_MIN = 0;
const STUB_MAX = 180;

const HeatIndexGaugeWidgetDefault = ({ onRequestEdit }) => {
  const isPublicView = !!getPublicDashboardToken();

  const customizeCta = (
    <div className="small">
      {'Click '}
      <button
        type="button"
        className="btn btn-link p-0 align-baseline"
        style={{ fontWeight: 600 }}
        onClick={onRequestEdit}
      >
        Customize
      </button>
      {' to configure this tile or choose another.'}
    </div>
  );

  const viewerMessage = (
    <div className="small text-muted">
      This tile isn’t configured yet.
    </div>
  );

  return (
    <div className="h-100 d-flex flex-column py-2 px-2">
      <div
        className="flex-grow-1 d-flex justify-content-center align-items-center position-relative"
        style={{ minHeight: 0 }}
      >
        {/* Ghosted gauge — fills the widget as the backdrop. */}
        <div
          aria-hidden="true"
          className="h-100 w-100 d-flex justify-content-center align-items-center"
          style={{
            opacity: 0.35,
            filter: 'grayscale(35%)',
            pointerEvents: 'none',
            minHeight: 0,
          }}
        >
          <DashboardHeatIndex
            value={STUB_VALUE}
            units={STUB_UNITS}
            min={STUB_MIN}
            max={STUB_MAX}
          />
        </div>

        {/* Floating call-to-action card layered over the ghosted gauge. */}
        <div
          className="position-absolute d-flex align-items-center justify-content-center"
          style={{
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            padding: '0.5rem',
          }}
        >
          <div
            className="shadow-sm rounded text-center"
            style={{
              background: 'rgba(255, 255, 255, 0.96)',
              border: '1px solid rgba(0, 0, 0, 0.08)',
              padding: '0.75rem 1rem',
              maxWidth: '220px',
              width: '100%',
            }}
          >
            {isPublicView ? viewerMessage : (
              <HasRolePrivileges
                targetRoleList={[RaaRoles.MANAGER, RaaRoles.ADMIN]}
                alternativeComponent={viewerMessage}
              >
                {customizeCta}
              </HasRolePrivileges>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

HeatIndexGaugeWidgetDefault.propTypes = {
  onRequestEdit: PropTypes.func,
};

HeatIndexGaugeWidgetDefault.defaultProps = {
  onRequestEdit: () => {},
};

export default HeatIndexGaugeWidgetDefault;
